import { createTheme, PaletteMode } from '@mui/material';

// Define theme settings for light and dark modes
export const getDesignTokens = (mode: PaletteMode) => ({
  palette: {
    mode,
    ...(mode === 'light'
      ? {
          // Light mode palette
          primary: {
            main: '#007BFF',
          },
          secondary: {
            main: '#f50057',
          },
          background: {
            default: '#f5f5f5',
            paper: '#ffffff',
          },
          text: {
            primary: 'rgba(0, 0, 0, 0.87)',
            secondary: 'rgba(0, 0, 0, 0.6)',
          },
        }
      : {
          // Dark mode palette
          primary: {
            main: '#66B2FF',
          },
          secondary: {
            main: '#f48fb1',
          },
          background: {
            default: '#121212',
            paper: '#1e1e1e',
          },
          text: {
            primary: '#ffffff',
            secondary: 'rgba(255, 255, 255, 0.7)',
          },
        }),
  },
  components: {
    MuiAppBar: {
      styleOverrides: {
        root: {
          boxShadow: mode === 'dark' ? '0 2px 10px 0 rgba(0, 0, 0, 0.5)' : undefined,
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: 'none',
        },
      },
    },
    // Listas suspensas (Autocomplete/Select) sempre OPACAS e acima de
    // qualquer campo: antes dava para ver o campo de trás por baixo das
    // opções, porque o papel do dropdown herdava fundo transparente.
    MuiAutocomplete: {
      styleOverrides: {
        paper: {
          backgroundColor: mode === 'dark' ? '#1e1e1e' : '#ffffff',
          backgroundImage: 'none',
          boxShadow:
            mode === 'dark'
              ? '0 8px 24px rgba(0, 0, 0, 0.6)'
              : '0 8px 24px rgba(0, 0, 0, 0.18)',
          border:
            mode === 'dark'
              ? '1px solid rgba(255, 255, 255, 0.12)'
              : '1px solid rgba(0, 0, 0, 0.12)',
        },
        popper: {
          zIndex: 1500,
        },
      },
    },
    MuiPopover: {
      styleOverrides: {
        paper: {
          backgroundColor: mode === 'dark' ? '#1e1e1e' : '#ffffff',
          backgroundImage: 'none',
        },
      },
    },
  },
});

// Create theme instances
export const createAppTheme = (mode: PaletteMode) => {
  return createTheme(getDesignTokens(mode));
};
